<template>
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">Posting</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-file">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">Postage Cost</h5>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 posting-tracker-alerts pt-4">
                  <div class="posting-tracker-alert" v-for="(alert, idx) in alerts" :key="idx">
                    <b-alert :variant="alert.status" :show="alert.status != null">
                      <span>{{ alert.message }}</span>
                    </b-alert>
                  </div>
                </div>

              </div>
            </div>

            <b-card no-body>
              <b-tabs pills card>
                <b-tab class="" v-for="tab in tabs" :title="tab.title" >
                  <b-table id="posting-tracker-table" striped hover bordered :fields="fields" :busy.sync="loading" :items="tableItems(tab.code)" :show-empty="true">


                    <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="postageCost">
                      <vcl-table :rows="3" :columns="fields.length"></vcl-table>
                    </template>

                    <template v-slot:cell(min_pages)="data">
                      <div class="input-group input-group-sm single-number-field">
                        <input type="number" min="0" step="1" v-model="data.item.min_pages" class="form-control" />
                      </div>
                    </template>

                    <template v-slot:cell(max_pages)="data">
                      <div class="input-group input-group-sm single-number-field">
                        <input type="number" min="0" step="1" v-model="data.item.max_pages" class="form-control" />
                      </div>
                    </template>

                    <template v-slot:cell(std_cost)="data">
                      <div class="input-group input-group-sm single-number-field">
                        <input type="number" min="0" step=".01" v-model="data.item.std_cost" class="form-control" />
                      </div>
                    </template>

                    <template v-slot:cell(currency)="data">
                      <div class="input-group input-group-sm single-number-field">
                        <input type="text" v-model="data.item.currency" class="form-control" />
                      </div>
                    </template>

                    <template v-slot:cell(actions)="data">
                      <div class="btn btn-sm btn-primary" @click="updateItem(tab, data.item)">Update</div>
                      <div class="btn btn-sm btn-primary" @click="deleteItem(tab, data.item)">Delete</div>
                    </template>

                    <template slot="bottom-row">
                      <td>
                        <div class="multiselect-default single">
                          <multiselect
                              v-model="newItem.postage_type"
                              select-label=""
                              deselect-label=""
                              :options="postageTypes(tab.code)"
                              :multiple="false"
                              placeholder="Select.."
                              label="type"
                              track-by="id"
                              :preselect-first="true"
                          ></multiselect>
                        </div>
                      </td>
                      <td>
                        <div class="multiselect-default single">
                          <multiselect
                              v-model="newItem.env_type"
                              select-label=""
                              deselect-label=""
                              :options="postageCost.env_types || []"
                              :multiple="false"
                              placeholder="Select.."
                              label="type"
                              track-by="id"
                              :preselect-first="true"
                          ></multiselect>
                        </div>
                      </td>
                      <td>
                        <div class="input-group input-group single-number-field">
                          <input type="number" min="0" step="1" v-model="newItem.min_pages" class="form-control" />
                        </div>
                      </td>
                      <td>
                        <div class="input-group input-group single-number-field">
                          <input type="number" min="0" step="1" v-model="newItem.max_pages" class="form-control" />
                        </div>
                      </td>
                      <td>
                        <div class="input-group input-group single-number-field">
                          <input type="number" min="0" step=".01" v-model="newItem.cost" class="form-control" />
                        </div>
                      </td>
                      <td>
                        <div class="input-group input-group single-number-field">
                          <input type="text" v-model="newItem.currency" class="form-control" />
                        </div>
                      </td>
                      <td>
                        <div class="btn btn-success" @click="addItem(tab, newItem)">Add</div>
                      </td>
                    </template>
                  </b-table>
                </b-tab>
              </b-tabs>
            </b-card>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { VclTable } from 'vue-content-loading'
import datePicker from 'vue-bootstrap-datetimepicker'
import { getDefaultConfig } from "../../helpers/datepickerHerler";
import axios from "../../axios";

const newItem = {
  postage_type: null,
  env_type: null,
  min_pages: 0,
  max_pages: 0,
  cost: .0,
  currency: "",
};

export default {
  name: 'PostageCost',
  components: {
    VclTable,
    datePicker,
  },
  data() {
    return {
      loading: false,
      alerts: {
        resend: { status: null, message: "" },
        setStatus: { status: null, message: "" },
      },
      fields: [
        {key: 'postage_type_name', label: 'Postage Type', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'envelope_type_name', label: 'Envelope Type', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'min_pages', label: 'Min. Pages', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'max_pages', label: 'Max. Pages', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'std_cost', label: 'Std. Cost', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'currency', label: 'Currency', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'actions', label: '', sortable: true, thClass: 'hover-pointer brand-color'},
      ],
      tabs: [
        { title: "UK", code: "UK", },
        { title: "Germany", code: "GER", },
        { title: "USA", code: "USA", },
        { title: "Australia", code: "AUS", },
        { title: "Singapore", code: "SGP", },
      ],
      newItem: {...newItem},
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    loadPostageCost() {
      this.loading = true

      this.$store.dispatch('loadPostageCost').finally(() => {
        this.loading = false
      })
    },
    deleteItem(tab, item) {
      if (confirm("Are you sure you want to delete this postage cost?")) {
        this.$store.dispatch('postageCostDeleteItem', {
          tab: tab,
          item: item,
        }).then(() => {
          this.$forceUpdate()
        })
      }
    },
    updateItem(tab, item) {
      this.$store.dispatch('postageCostUpdateItem', {
        tab: tab,
        item: item,
      })
    },
    addItem(tab, item) {
      this.$store.dispatch('postageCostAddItem', {
        tab: tab,
        item: item,
      }).then(() => {
        this.newItem = {...newItem};
        this.loadPostageCost();
      })
    }
  },
  computed: {
    postageCost: {
      get() {
        return this.$store.getters.getPostageCost
      }
    },
    tableItems: {
      get() {
        return (code) => {
          if (this.postageCost[code]) {
            return this.postageCost[code].costs;
          }
          return [];
        }
      }
    },
    postageTypes: {
      get() {
        return (code) => {
          if (this.postageCost[code]) {
            return this.postageCost[code].types;
          }
          return [];
        }
      }
    },
  },
  created() {
    this.loadPostageCost()
  },
}

</script>

<style scoped>
table >>> tbody, table >>> thead {
  text-align: center;
}

.table >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}
</style>
